<template>
  <div class="stat">
    <div class="stat-container">
      <div class="top-banner">
        <van-nav-bar 
          left-text="返回" 
          :title="statTitle"
          left-arrow 
          @click-left="onClickLeft"
        >
        </van-nav-bar>
      </div>
      <div class="content">
        <div class="stats-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="loadBusy" infinite-scroll-distance="30">
          <van-pull-refresh v-model="loadBusy" @refresh="onRefresh" style="min-height: 100%">
          <template v-if="list.length > 0">
            <van-cell-group>
              <van-cell title="日期">
                <div class="stat-val">
                  <span v-if="type == 'play'">完播人数</span>
                  <span v-if="type == 'play'">观看人数</span>

                  <span v-if="type == 'question'">正确人数</span>
                  <span v-if="type == 'question'">答题人数</span>

                  <span v-if="type == 'redpack'">发放次数</span>
                </div>
              </van-cell>
              <van-cell :title="stat.date" v-for="stat in list" :key="stat.id">
                <div class="stat-val">
                  <span v-if="type == 'play'">{{ stat.total_play_finish }} </span>
                  <span v-if="type == 'play'">{{ stat.total_play_count }} </span>

                  <span v-if="type == 'question'">{{ stat.correct_answer_question }} </span>
                  <span v-if="type == 'question'">{{ stat.total_answer_question }} </span>
                  
                  <span v-if="type == 'redpack'">{{ stat.total_rp_count }} </span>
                </div>
              </van-cell>
            </van-cell-group>
          </template>
          <template v-else>
            <van-empty description="暂无更多内容" />
          </template>
          </van-pull-refresh>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { queryStat } from '@/api/stats'

export default {
  name: 'SupportStat',
  data() {
    return {
      type: '',
      loadBusy: false,
      list: [],
      meta: {
        last_id: -1,
        type: '',
      },
    }
  },
  computed: {
    ...mapState(['user']),
    statTitle() {
      if (this.type == 'redpack') {
        return '发放红包'
      } else if (this.type == 'play') {
        return '观看人数'
      } else if (this.type == 'question') {
        return '答题人数'
      } else if (this.type == 'customer') {
        return '客户数'
      } 
    },
    res_url() {
      return window.__config__.res_url;
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.type = this.$route.params.type;
      this.loadData({type: this.type})
    },
    onClickLeft() {
      this.$router.back();
    },
    onRefresh() {
      this.loadData({
        query_last_id: -1,
        type: this.type
      })
    },
    loadData({ query_last_id = -1, type } = {}) {
      this.loadBusy = true;
      queryStat(type, {
        last_id: query_last_id
      }).then((resp) => {
        // console.log(resp)
        let { last_id, stats } = resp.data
        
        this.list = query_last_id == -1 ? stats : this.list.concat(stats)
        this.loadBusy = false
        this.meta = {
          last_id,
          type
        }
      })
    },
    loadMore() {
      if (this.meta.last_id > 0) {
        this.loadData({
          query_last_id: this.meta.last_id,
          type: this.meta.type
        })
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.stat-container {
  height: calc(100vh - 60px);
  width: 100%;
  display: flex;
  flex-direction: column;
  .top-banner {
    flex: 0 0 46px;
  }
  .content {
    flex: 1 1 auto;
    width: 100%;
    overflow: hidden;
    background: #e3e3e3;
    .stats-list {
      height: 100%;
      width: 100%;
      overflow-y: scroll;
      .stat-val {
        display: flex;
        justify-content: flex-end;

        span {
          display: inline-block;
          width: 80px;
        }
      }
    }
  }
}
.video_container {
  width: 90vw;
  height: 52vw;
  video {
    width: 100%;
  }
}
.headicon {
  width: 50px;
  height: 50px;
  border-radius: 25px;
}
</style>
